import { visitationScheduleTypes } from "../../../constants/visitationScheduleTypes";
import { Subheading } from "../../../design/heading";
import { VisitationScheduleForm } from "../../../models/Forms/VisitationScheduleForm";
import { VisitationSchedule } from "../../../models/VisitationSchedule";
import { VisitationScheduleType } from "../../../models/VisitationScheduleType";

interface ChooseVisitationScheduleTypeProps {
  form: VisitationScheduleForm;
  setForm: React.Dispatch<React.SetStateAction<VisitationScheduleForm>>;
}

export const ChooseVisitationScheduleTypeStep: React.FC<
  ChooseVisitationScheduleTypeProps
> = ({ form, setForm }) => {
  const { type } = form;
  return (
    <div className="grid justify-center w-full max-w-3xl grid-cols-1 gap-4 mt-8 sm:grid-cols-2 md:grid-cols-3">
      {Object.entries(visitationScheduleTypes).map(([key, value]) => (
        <div
          key={key}
          className={`flex flex-col items-center w-full p-6 rounded-lg shadow-md cursor-pointer transition-colors ${
            type === key
              ? "bg-blue-100 dark:bg-blue-900"
              : "bg-gray-100 hover:bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-700"
          }`}
          onClick={() => {
            setForm((prev) => ({
              ...prev,
              type: key as VisitationScheduleType,
              interval:
                visitationScheduleTypes[key as VisitationScheduleType]
                  .supportedIntervals[0],
            }));
          }}
        >
          {/* <img
                src={assets[key as keyof typeof assets]}
                alt={key}
                className="w-24 h-24 mb-3"
                /> */}
          <Subheading>{value.title}</Subheading>
        </div>
      ))}
    </div>
  );
};
